import { Timer } from "./timer.js";
export default function (callback, delay, time) {
    var t = new Timer;
    delay = delay == null ? 0 : +delay;
    t.restart(function (elapsed) {
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}
